<template>
  <v-row>
    <v-col cols="12">
      <h2>{{ $t('first_deposit.head') }}</h2>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title> {{ $t('first_deposit.head_list') }} </v-card-title>
        <v-card-actions class="pb-0 d-flex align-start">
          <v-row no-gutters>

            <span style="display: flex; margin-left: 5px;">
              <date-picker-input ref="startDate" :date="dateFrom" :label="$t('report_bonus.date_from')"
                @setValue="dateFrom = $event" style="max-width: 250px;" />
              <!-- <v-dialog ref="dialog" v-model="modal2" :return-value.sync="time2" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="time2" prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs"
                    v-on="on" class="time-start"></v-text-field>
                </template>
                <v-time-picker v-if="modal2" v-model="time2" format="24hr">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modal2 = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.dialog.save(time2)">
                    OK
                  </v-btn>
                </v-time-picker>
              </v-dialog> -->
            </span>
            <span style="display: flex; margin-left: 5px;">
              <date-picker-input ref="endDate" :date="dateTo" :label="$t('report_bonus.date_to')"
                @setValue="dateTo = $event" style="max-width: 250px;" />
              <!-- <v-dialog ref="dialog2" v-model="modal3" :return-value.sync="time3" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="time3" prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs"
                    v-on="on" class="time-start"></v-text-field>
                </template>
                <v-time-picker v-if="modal3" v-model="time3" format="24hr">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modal3 = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.dialog2.save(time3)">
                    OK
                  </v-btn>
                </v-time-picker>
              </v-dialog> -->
            </span>
            <!-- <span style="display: flex; margin-left: 5px;">
              <div
                style="width: 98px; height: 38px; text-agent: center; background: #e5e5e5; border-radius: 8px; color: #737076; display: flex; justify-content: center; align-items: center;">
                {{ $t('report_bonus.header5') }} </div>
              <v-select :items="roles" item-text="label" v-model="valType" outlined dense style="max-width: 110px;" />
            </span> -->
            <v-btn color="primary" @click="searchBonus" class="" style="margin-left: 5px;"> {{ $t('search') }} </v-btn>
            <!-- <v-btn color="warning" @click="preloadExportCsv" class="" style="margin-left: 5px;"> {{ $t('report_bonus.export_excel') }} </v-btn> -->
          </v-row>
        </v-card-actions>
        <v-card-actions class="pt-0">
          <v-data-table mobile-breakpoint="0" style="width: 100%" :headers="headers" :no-data-text="$t('not_found')"
            :no-results-text="$t('not_found')" :options.sync="pagination" :server-items-length="pagination.totalItems"
            :items-per-page="pagination.rowsPerPage" :loading="loading" :page.sync="pagination.currentPage" :footer-props="{
              'items-per-page-options': [10, 25, 30, 40, 50],
            }" :items="members">

            <template v-slot:[`item.amount`]="{ item }">
              {{ item.amount | currency }}
            </template>
          </v-data-table>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import DatePickerInput from '@/components/input/DatePickerInput.vue'
import SelectInput from '@/components/input/SelectInput.vue'
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import store from '@/store';
export default {
  components: {
    DatePickerInput,
    SelectInput,
  },
  data() {
    return {
      dateFrom: moment().subtract(3, 'days').format('YY-MM-DD'),
      dateTo: moment().format('YY-MM-DD'),
      date: null,
      currentMemberDetail: {},
      searchData: null,
      time: null,
      time2: "00:00",
      time3: "23:59",
      menu2: false,
      modal2: false,
      menu3: false,
      modal3: false,
      valPartner: "พันธมิตร",
      valType: "ทั้งหมด",
      headers: [
        {
          text: this.$t('first_deposit.header1'),
          value: 'phone',
          width: '200px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('first_deposit.header2'),
          value: 'name',
          width: '200px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('first_deposit.header3'),
          value: 'amount',
          width: '200px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('first_deposit.header4'),
          value: 'date',
          width: '200px',
          align: 'center',
          sortable: false,
        },
      ],
      members: [],
      loading: false,
      pagination: {
        currentPage: 1,
        rowsPerPage: 25,
        totalItems: 0,
      },
      total: 0,
      dummy: true,
    }
  },
  watch: {
    pagination: {
      async handler(newValue, oldValue) {
        let cont = false
        if (oldValue.page !== newValue.page) cont = true
        if (oldValue.itemsPerPage !== newValue.itemsPerPage) cont = true
        if (oldValue.sortBy !== newValue.sortBy) cont = true
        if (oldValue.sortDesc !== newValue.sortDesc) cont = true
        // await this.getBonus(newValue.page, newValue.itemsPerPage, this.$refs.startDate.value, this.$refs.endDate.value, this.searchData, this.valPartner, this.valType)
        if (cont) await this.getFirstDeposit(newValue.page, newValue.itemsPerPage, this.$refs.startDate.value, this.$refs.endDate.value, this.searchData, this.valPartner, this.valType)
        if (cont) await this.getFirstDeposit(newValue.page, newValue.itemsPerPage, this.$refs.startDate.value, this.$refs.endDate.value, this.searchData, this.valPartner, this.valType)
      },
      deep: true,
    },
  },
  async created() {
    this.addLogPage()
  },
  methods: {
    async addLogPage() {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          data = {
            ip: res.data.ip,
            name: 'รายงานฝากแรก',
            url: window.location.href,
            detail: 'รายงานฝากแรก',
            admin: userSystem.name ? userSystem.name : '',
          }
        )
        await this.$store.dispatch('addLogPage', data)
      } catch (e) {
        // if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
        //   this.$swal.fire({
        //     icon: 'error',
        //     title: e.message,
        //   })
        // }
      }
    },
    async searchBonus() {
      this.dummy = false
      await this.getFirstDeposit(
        1,
        this.pagination.rowsPerPage,
        this.$refs.startDate.value,
        this.$refs.endDate.value,
      )
    },
    async getFirstDeposit(page, row, time_from, time_to) {
      this.loading = true
      this.members = []
      // console.log(valArr);
      let rs = await this.$store.dispatch('getAccountingFirstDeposit', {
        page: page,
        rows: row,
        time_from: this.formatDateYYYY(time_from) ,
        time_to: this.formatDateYYYY(time_to),
      })
      this.pagination.totalItems = rs.count
      this.totalRows = rs.count ? Number(rs.count) : ''
      rs.data.forEach(element => {
        this.members.push({
          id: element.id,
          phone: element.phone,
          name: element.name,
          amount: element.amount,
          date: element.createdat ? moment(element.createdat).format('YY-MM-DD HH:mm') : '',
        })
      })
      this.loading = false
    },
    formatDateYYYY(date) {
      const dateConv = date?.length > 8 ? date.substring(2) : date
      return moment(`20${dateConv}`).format('YYYY-MM-DD')
    },
  },
}
</script>
<style scoped>
@import '../../styles/custom.css';
</style>
